import React, { useEffect } from "react";
import Pagination from "rc-pagination";
import { connect } from "react-redux";
import { Alert } from "reactstrap";


// components
import WishlistCardContainer from "../../../components/wishlist/WishlistCardContainer";
import ListHeader from "../../../components/wishlist/components/ListHeader";

// labels
import { LB_EMPTY_TABLE } from "../../../components/i18n/i18n";

// actions
import { setViewMode, setApp, clearState } from "../../../redux/actions/generalActions/mainActions";
import { setFilter, setTableParams } from "../../../redux/actions/generalActions/listActions";
import { setForm, setItem } from "../../../redux/actions/generalActions/formActions";
import { add, search } from "../../../redux/actions/todoFluye/wishlistActions";

const WishlistList = props => {
    const udn = JSON.parse(localStorage.getItem('selectedUdn')) || null
    const { pageSize, pageIndex, totalSize, listDomainObjects:wishlists, filter, currentPage } = props.listState

    useEffect( () => {
        if(!filter || filter?.searchType == 'REQUEST')
            props.setFilter({
                udn:{ id: udn?.id },
                searchType: 'WISHLIST'
            })
    },[])

    useEffect(()=> {
        if(!filter || filter?.searchType == 'REQUEST')
            return

        refreshDataList()
    },[filter, pageIndex, pageSize])


    useEffect(()=> {
        if (props.app !== null)
            props.setApp(props.app);

        return () => {
            clearState()
        }
    }, [])

    const refreshDataList = () => props.search(pageIndex, pageSize, currentPage, filter)

    const onPageChange = page => {
        let currentIndex = (page - 1) * pageSize
        props.setTableParams( pageSize, currentIndex, totalSize, page );
    }

    return <>
        <ListHeader />

        {
            (!wishlists || wishlists.length == 0) ? <Alert color="warning"> <i className={'fa fa-exclamation-triangle'} aria-hidden="true" />{LB_EMPTY_TABLE} </Alert>
            : wishlists.map( (wishlist, index) => <WishlistCardContainer
                key={`wl-card-${index}`}
                wishList={wishlist}
            />)
        }

        <div className={'mt-2em '}>
            <Pagination
                locale={'es_ES'}
                current={ currentPage }
                pageSize={pageSize}
                total={totalSize}
                onChange={onPageChange}
            />
        </div>
    </>
}

const mapStateToProps = state => ({
    mainState: state.mainProps,
    listState : state.listProps,
})

const mapActionsToProps = ({
    add,
    search,
    setApp,
    setItem,
    setForm,
    setFilter,
    clearState,
    setViewMode,
    setTableParams,
})

export default connect(mapStateToProps, mapActionsToProps)(WishlistList)